<ion-label class="ion-text-start">
  {{ label }}
</ion-label>
@if (_options?.length > 0) {
  <ion-radio-group [formControl]="control">
    @for (item of _options; track item.value) {
      <ion-radio
        color="primary"
        labelPlacement="end"
        justify="start"
        mode="md"
        [disabled]="control?.disabled"
        [name]="item.value"
        [value]="item.value"
        [ariaLabel]="item.label"
        [attr.data-value]="item.value">
        {{ item.label }}
      </ion-radio>
    }
  </ion-radio-group>
}

@if (hasErrors) {
  <div class="error-wrapper">
    <c-validation-error [validationMessages]="control.errors" [controlValue]="control.value" />
  </div>
}
